/**
 * Created by Amit Panghal
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {
    IScatterAttentionConfig,
    ScatterAttentionController
} from "@nolimitcity/slot-game/bin/game/reelstoppresentation/scatterattention/ScatterAttentionController";
import {TimelineLite, TweenLite} from "gsap";
import {TractorBeamGameConfig} from "../../TractorBeamGameConfig";
import {TractorBeamSoundConfig} from "../../TractorBeamSoundConfig";

export class TractorBeamScatterAttentionController extends ScatterAttentionController {

    // TODO: when we can update the slot-game, use the _scatterCounter instead.
    private _attentionCounter:number = 0;
    private _isAttentionPlaying:boolean = false;
    private _winTimeline:TimelineLite;
    private _quickStop:boolean;

    constructor(index:number, config:IScatterAttentionConfig) {
        super(index, config, false);
        this._winTimeline = new TimelineLite();
        this._winTimeline.play();
    }

    /**
     * Function called on reel bounce. Clearing symbol attention states on last reel
     * @param data
     */
    public onReelBounce(data:IReelStoppedData):void {
        this.attentionTrigger(data.reelId);
        this._quickStop = data.quickStop;
        if(data.reelId === 4) {
            // play no win on the attention symbols.
            if(this._isAttentionPlaying) {
                for(let reelId:number = 0; reelId < 4; reelId++) {
                    const symbolId:number = this._scatterPositions[reelId];
                    if(symbolId > -1) {
                        const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
                        if(scatter) {
                            scatter.changeState({
                                state : TractorBeamGameConfig.instance.SYMBOL_STATES.normal,
                                fadeInDuration : 0.1
                            });
                        }
                    }
                }
                //this.dispatchCompleteEvent(data.reelId);
            }
            if(this._freespinTriggered) {
                SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.FS_WIN_REEL5);
                SlotGame.sound.fadeAmbience(0, 3000);
            }
        }
        this.dispatchCompleteEvent(data.reelId);

        //super.onReelBounce(data);
    }

    /**
     * Function to play attention animation. Animation starts on second scatter symbol.
     * @param data
     */
    protected playAttentionAnimation(data:IReelStoppedData):void {
        this._attentionCounter++;
        if(this._attentionCounter > 1) {
            for(let reelId:number = 0; reelId <= data.reelId; reelId++) {
                this.tryPlayScatterAttentionState(reelId);
            }

            this._isAttentionPlaying = true;
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    private attentionTrigger(reelId:number) {
        if(!(this._gameData!.mode === GameMode.FREESPIN)) {
            const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, this._scatterPositions[reelId]);
            if(scatter && this._scatterPositions[reelId] > -1) {
                if(this._scatterCounter < 2 && !(reelId >= 3 && this._scatterCounter < 1)) {
                    if(!(reelId >= 4 && this._scatterCounter < 2)) {
                        SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.SCATTER_ATTENTION);
                    }
                    this._scatterCounter++;
                } else if(this._scatterCounter >= 2) {
                    SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.SCATTER_WIN);
                    this._scatterCounter++;
                }
            }
        } else {
            [0, 1, 2].forEach((symId:number) => {
                const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symId);
                if(symbol && symbol.symName === "S") {
                    SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.SCATTER_ATTENTION);
                }
            });
        }
    }

    /**
     * Function to change symbol state to attention. TODO: Obsolete
     * @param reelId
     */
    private tryPlayScatterAttentionState(reelId:number):void {
        const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, this._scatterPositions[reelId]);
        if(scatter) {
            /*scatter.changeState({
                state: TractorBeamGameConfig.instance.SYMBOL_STATES.attention,
                fadeInDuration: 0.1,
                replay: false
            });*/
        }
    }

    /**
     * Function to play win animation on scatter symbols.
     * @param data
     */
    protected playWinAttentionAnimation(data:IReelStoppedData):void {
        let symbolState:ISymbolStateConfig = TractorBeamGameConfig.instance.SYMBOL_STATES.win;
        if(data.reelId < 4) {
            symbolState = TractorBeamGameConfig.instance.SYMBOL_STATES.attention;
        }
        this.animateOnWinAttention(data, symbolState);
    }

    /**
     * Function to add animation to scatter symbols upon win.
     * @param data
     * @param symbolState
     */
    private animateOnWinAttention(data:IReelStoppedData, symbolState:ISymbolStateConfig):void {
        for(let reelId:number = 0; reelId <= data.reelId; reelId++) {
            if(this._scatterPositions[reelId] === -1) {
                continue;
            }

            const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, this._scatterPositions[reelId]);
            if(!scatter) {
                continue;
            }
            scatter.changeState({
                state : TractorBeamGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.1
            });

            let winTl:TimelineLite = new TimelineLite({
                onComplete : () => {
                    if(!this._quickStop) {
                        scatter.changeState({
                            state : symbolState,
                            fadeInDuration : 0.1
                        });
                    }
                    winTl.pause();
                    winTl.kill();
                }
            });
            winTl.add(new TweenLite(scatter!.scale, 0.2, {x : 0.8, y : 0.8}));
            winTl.add(new TweenLite(scatter!.scale, 0.2, {x : 1.2, y : 1.2}));
            winTl.add(new TweenLite(scatter!.scale, 0.2, {x : 1, y : 1}));
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    /**
     * Resets animation upon spin stops.
     */
    protected resetFeature():void {
        super.resetFeature();
        this._attentionCounter = 0;
        this._scatterCounter = 0;
        this._isAttentionPlaying = false;
    }
}
